"use client";

import { ShoppingBag } from "lucide-react";
import { useShoppingCartStore } from "@/lib/client/stores";
import type { CartItemForClient } from "@/lib/shared/types/interfaces";
import { Button, Text } from "@/ui";

/**
 * ShoppingCartIcon component - Shopping cart button with item count
 */
export const ShoppingCartIcon = () => {
  const { isOpen, setIsOpen, cartItems } = useShoppingCartStore();

  return (
    <Button
      className="items-center px-1 sm:px-2"
      variant="ghost"
      data-testid="cart-toggle"
      onClick={() => {
        setIsOpen(!isOpen);
      }}
    >
      <ShoppingBag
        className="h-6 w-6 flex-shrink-0"
        aria-hidden="true"
      />
      <Text className="text-sm font-medium">
        {cartItems.reduce((sum: number, item: CartItemForClient) => sum + item.quantity, 0)}
      </Text>
    </Button>
  );
};
